const deixou_de_frequentar = {
  path: "/deixou-de-frequentar",
  redirect: "/deixou-de-frequentar",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Manutenção de Matrículas",
  },
  children: [
    {
      path: "/deixou-de-frequentar",
      name: "deixou_de_frequentar",
      component: () =>
        import("@/views/DeixouDeFrequentar/DeixouDeFrequentar.vue"),
    },
  ],
};
export { deixou_de_frequentar };
